<template>
  <br />
  <div>
    <div class="mb-3 tips-container">
      <div class="row">
        <div class="col-2">
          <img
            class="tips-img"
            src="../assets/images/tips.png"
            alt="Tip Image"
          />
        </div>
        <div class="col-10 d-flex align-items-center">
          <p>{{ consejoTexto }}</p>
        </div>
      </div>
    </div>
  </div>
  <br />
</template>

<script>
import api from "@/services/api";

export default {
  name: "Tips",
  data() {
    return {
      consejoTexto: "", // Almacena el texto del consejo
    };
  },
  methods: {
    async fetchConsejo() {
      try {
        const response = await api.get("/vwconsperfs/tips/random/" +
            window.sessionStorage.getItem("idPerfil")
        );
        this.consejoTexto = response.data.consejoTexto;
      } catch (error) {
        console.error("Error al obtener el consejo:", error);
        this.consejoTexto = "No se pudo cargar el consejo.";
      }
    },
  },
  mounted() {
    this.fetchConsejo(); // Obtiene el consejo cuando el componente se monta
  },
};
</script>

<style scoped>
.tips-img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.tips-container {
  width: 100%;
  height: 200px;
  padding: 15px;
  border-radius: 10px;
  border: 5px solid gold;
  outline: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: white;
  color: #333;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 20px;
  resize: none;
  overflow: hidden; /* Asegura que el texto no se desborde */
}
</style>
